var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check-circle_24px",
    "data-name": "icon/check-circle_24px",
    transform: "translate(0.397 0.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(4.6 4.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0.002 0.002)",
    fill: "rgba(246,201,142,0.2)",
    stroke: "#f6c98e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M26.986,3.044,26,3.888a9.382,9.382,0,0,1-12.59-.305A9.379,9.379,0,0,0,1.958,2.439L1,3.044",
    transform: "translate(9.009 18.754)",
    fill: "none",
    stroke: "#fdffff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 56,
    height: 56,
    transform: "translate(-0.397 -0.397)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrder);
export default __webpack_public_path__ + "static/media/pending_order.b520312137d9cbf5fd89ba48ba512636.svg";
export { ForwardRef as ReactComponent };